import React from "react";
import { Modal, Button } from "antd";

const ModalAlertaMatricula = ({ visible, tipo, turma, escola, onClose }) => {
    const handleImportar = () => onClose("importar");
    const handleManual = () => onClose("manual");
    const handleSalvar = () => onClose("salvar");

    let mensagem = "";
    let botoes = [];

    if (tipo === 1) {
        mensagem = `Foi encontrada uma matrícula anterior na escola "${escola}" (turma ${turma}). Pretende importar as possíveis notas?`;
        botoes = [
            <Button key="importar" type="primary" onClick={handleImportar}>
                Importar notas
            </Button>,
            <Button key="salvar" onClick={handleSalvar}>
                Apenas salvar
            </Button>
        ];
    } else if (tipo === 2) {
        mensagem = "O ano letivo já se encontra a decorrer. Como deseja proceder?";
        botoes = [
            <Button key="manual" type="primary" onClick={handleManual}>
                Inserir manualmente
            </Button>,
            <Button key="salvar" onClick={handleSalvar}>
                Apenas salvar
            </Button>
        ];
    }

    return (
        <Modal title="Alerta de Matrícula" visible={visible} onCancel={() => onClose(null)} footer={botoes}>
            <p>{mensagem}</p>
        </Modal>
    );
};

export default ModalAlertaMatricula;
